import * as z from "zod";

export const getSupportAiPricing = {
  name: "getSupportAiPricing" as const,
  input: z.object({}),
  output: z.object({ monthlyOrders: z.number(), platformPrice: z.number() }),
};

export type GetSupportAiPricingOutput = z.infer<
  typeof getSupportAiPricing.output
>;
